import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import Breadcrumb from '../../Components/Breadcrumb';

function MemberJournal(props) {
  return (
    <Wrapper>
      <div className="tda-header">
        <h2>北市牙醫雜誌</h2>
        <Breadcrumb second="會員專區" third="北市牙醫雜誌" />
      </div>

      <a
        href="https://drive.google.com/drive/folders/1JetvnUGpF00I5Ezbp5oT7HSYrh7OIE8s?usp=sharing"
        target="_blank"
        rel="noreferrer">
        點我觀看
      </a>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

export default withPageEntry(MemberJournal);
